<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.attendance_review'),
                        href: null,
                    },
                    {
                        name: meta.info.date,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-wrap justify-between">
            <div class="flex gap-x-1 items-center">
                <AppButton element="InertiaLink" :desired-action="links.prev_week.active" :href="links.prev_week.url">
                    &laquo;
                </AppButton>
                <AppButton element="InertiaLink" :desired-action="links.prev_day.active" :href="links.prev_day.url">
                    &lt;
                </AppButton>
            </div>
            <div class="flex gap-x-1 items-center">
                <AppButton
                    v-for="weekday in links.weekdays"
                    :key="weekday.url"
                    element="InertiaLink"
                    :desired-action="weekday.active"
                    :href="weekday.url"
                >
                    {{ weekday.text }}
                </AppButton>
            </div>
            <div class="flex gap-x-1 items-center">
                <AppButton element="InertiaLink" :desired-action="links.next_week.active" :href="links.next_week.url">
                    &gt;
                </AppButton>
                <AppButton element="InertiaLink" :desired-action="links.next_day.active" :href="links.next_day.url">
                    &raquo;
                </AppButton>
            </div>
        </div>

        <div v-if="meta.info.is_weekend">
            <div class="text-4xl my-5 flex justify-center">
                {{ $t('messages.enjoy_the_weekend') }}
            </div>
            <div class="flex justify-center">
                <img
                    class="w-full md:w-1/2"
                    src="/img/utils/undraw_chilling_8tii.svg"
                    :alt="$t('messages.enjoy_the_weekend')"
                />
            </div>
        </div>
        <div v-else-if="meta.info.is_holiday">
            <div class="text-4xl my-5 flex justify-center">
                {{ $tc('messages.holidays', 1) }}
            </div>
            <div class="flex justify-center">
                <img
                    class="w-full md:w-1/2"
                    src="/img/utils/undraw_festivities_tvvj.svg"
                    :alt="$tc('messages.holidays', 1)"
                />
            </div>
        </div>
        <div v-else-if="meta.info.is_complete">
            <div class="text-4xl my-5 flex justify-center">
                {{ $t('messages.day_completed') }}
            </div>
            <div class="flex justify-center">
                <img
                    class="w-full md:w-1/2"
                    src="/img/utils/undraw_check_boxes_m3d0.svg"
                    :alt="$tc('messages.holidays', 1)"
                />
            </div>
        </div>
        <div v-else>
            <div class="md:grid md:grid-cols-2 md:gap-6 mt-5">
                <div v-for="turn in turns" :key="turn.name">
                    <h3 class="title">{{ turn.name }}</h3>
                    <div
                        class="mb-2 flex gap-x-1 items-center"
                        v-for="gradeLevel in turn.grade_levels"
                        :key="gradeLevel.name"
                    >
                        <AppButton
                            element="InertiaLink"
                            v-for="group in gradeLevel.groups"
                            :key="group.id"
                            desired-action
                            :href="group.url"
                        >
                            {{ group.name }}
                        </AppButton>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'links', 'turns'],
};
</script>
